import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TERMS_SECTIONS, TERMS_UPDATED } from "@/lib/terms";

export default function Terms() {
  return (
    <div className="min-h-screen bg-nm-bg" data-testid="terms-page">
      <div className="mx-auto max-w-3xl px-6 py-14 sm:py-20">
        <Link to="/" data-testid="terms-back-link"
          className="inline-flex items-center gap-2 text-sm text-nm-primary hover:text-nm-coral transition-colors duration-200">
          <ArrowLeft size={15} /> Back to Manage(Meant) Excellence
        </Link>
        <div className="mt-10 text-[11px] font-semibold uppercase tracking-[0.22em] text-nm-coral">Manage(Meant) Excellence</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-nm-ink mt-3 leading-tight">Terms &amp; Privacy</h1>
        <p className="mt-4 text-nm-neutral" data-testid="terms-updated">Last updated {TERMS_UPDATED}. Written in plain language on purpose.</p>
        <div className="mt-12 space-y-12">
          {TERMS_SECTIONS.map((s) => (
            <section key={s.id} id={s.id} data-testid={`terms-section-${s.id}`}>
              <h2 className="font-serif text-2xl text-nm-primary">{s.title}</h2>
              <div className="mt-4 space-y-4">
                {s.body.map((p, i) => <p key={i} className="text-nm-ink/85 leading-relaxed">{p}</p>)}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
